// src/components/GamesDetails.jsx
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import playbtn from "../assets/images/playwhite.png"
import PlaybuttonHover from "../assets/images/playblack.png"
import contArrow from "../assets/images/contArrow.png"
import contArrowblack from "../assets/images/contArrowblack.png"
import Rules from "./rules/Rules"
import Popular from "./PopularGames/Popular"
import logo from "../assets/images/logo.png"
import "../assets/css/iframes.css"
import Screen from "../components/popupScreen/Screen"
import aviatorImg from "../assets/images/games/aviator.png";
import rouletteImg from "../assets/images/games/roulette.png";
import windropImg from "../assets/images/games/windrop.png";
import { Helmet } from "react-helmet-async";
const STATIC_GAMES = {
  aviator: {
    id: 1,
    gamename: "aviator",
    titlename: "Aviator",
    game_type_name: "Live Games",
    game_type: "3",
    status: 1,
    image: aviatorImg,
    banner_video: "https://iqplay-media.s3.ap-south-1.amazonaws.com/banner_video_8b2b6fdb-5b26-4308-bbbf-839ac0995e4e.mp4",
    poster_image: aviatorImg,
      metaTitle: "Iqplay - Aviator",
    gameinfo: "Experience the thrill of Aviator — watch the multiplier climb and cash out before it flies away!",
   rules: [
  { id: 1, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480356_Frame%202147237758%284%29.png", rule: "Bet before you take off." },
  { id: 2, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480497_Frame%202147237758%285%29.png", rule: "Watch as your Rocket takes off and your winnings increase." },
  { id: 3, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480597_Frame%202147237758%286%29.png", rule: "Cash out before the Rocket disappears and wins X times more!" },
 { id: 4, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480697_Frame%202147237758%287%29.png", rule: "Cash out before the Rocket disappears and wins X times more!" },
  { id: 5, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480812_Frame%202147237758%288%29.png", rule: "Press the \"Cash Out\" button to cash out your winnings. Your win is your bet multiplied by the Cash Out multiplier." },
  { id: 6, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769067480902_Frame%202147237758%289%29.png", rule: "On the bottom, the View bets panel is located. Here player can see all the bets placed in the current round and Previous round." },
],
    popular: 1,
  },
    roulette: {
    id: 1,
    gamename: "roulette",
    titlename: "Roulette",
    game_type_name: "Casino Games",
    game_type: "3",
    status: 1,
    image: rouletteImg,
    banner_video: "https://iqplay-media.s3.ap-south-1.amazonaws.com/roulette.mp4",
    poster_image: rouletteImg,
      metaTitle: "Iqplay - roulette",
    gameinfo: "This reimagined and simplified version of the vastly popular roulette game, provides the player with 12 numbers to bet on.",
   rules: [
  { id: 1, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078907722_Frame%202147237758%2825%29.png", rule: "Players have a designated time to place their bets on the Roulette table. The available betting options are similar to those in traditional Roulette but are adjusted to match the reduced number of pockets." },
  { id: 2, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078907929_Frame%202147237758%2826%29.png", rule: "After the betting phase, the Roulette wheel is spun, and a small ball is released. As the wheel slows down, the ball comes to rest in one of the 12 pockets. The winning number is determined by the pocket where the ball lands." },
  { id: 3, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078908013_Frame%202147237758%2827%29.png", rule: "Players who have placed bets on the winning number or category receive payouts based on the type of bet they made and the Roulette's specific payout table." },
 { id: 4, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078908150_Frame%202147237758%2828%29.png", rule: "Payouts are typically adjusted to account for the smaller number of pockets. Multipliers are displayed in Pay table. After each spin, players can choose to place new bets and continue playing." },
  { id: 5, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078908248_Frame%202147237758%2829%29.png", rule: "The player can use it to bet the same amount which was used in previous round." },
  { id: 6, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/1769078908348_Frame%202147237758%2830%29.png", rule: "The player can use it to change the previous bet they have placed for the current round." },
],
    popular: 1,
  },

      gocolor: {
    id: 1,
    gamename: "gocolor",
    titlename: "Go Color",
    game_type_name: "Casino Games",
    game_type: "3",
    status: 1,
    image: rouletteImg,
    banner_video: "https://iqplay-media.s3.ap-south-1.amazonaws.com/gocolor.mp4",
    poster_image: rouletteImg,
      metaTitle: "Iqplay - roulette",
    gameinfo: "In Go Color, players match dice colors for rewards, with three of the same color earning a maximum payout.",
   rules: [
  { id: 1, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/gocolor1.png", rule: "Place bets on color blocks. Three colorful dice will be rolled. Your aim is to match the dice colors with your bets. To win more matches mean higher payouts." },
  { id: 2, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/gocolor2.png", rule: "Choose one or more color blocks to bet on. Use different chips, but don’t exceed the maximum limit. Use “Undo”, “Clear”, “Again” or “2x” to adjust your bets." },
  { id: 3, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/gocolor3.png", rule: "After the betting time ends, three dice are rolled. Each die shows one of six vibrant colors. These results will be compared to your chosen bets." },
 { id: 4, image: "https://lootrixdevgaames.s3.ap-south-1.amazonaws.com/rules/gocolor4.png", rule: "Your winning amount will be based on your selected color and it’s multiplier." },

],
    popular: 1,
  },


       windrop: {
    id: 1,
    gamename: "windrop",
    titlename: "win drop",
    game_type_name: "Casino Games",
    game_type: "3",
    status: 1,
    image: windropImg,
    banner_video: "https://iqplay-media.s3.ap-south-1.amazonaws.com/windrop.mp4",
    poster_image: windropImg,
      metaTitle: "Iqplay - windrop",
    gameinfo: "Windrop is a game where players drop a ball into a vertical board filled with pegs, aiming to land it in a prize slot at the bottom. The ball bounces unpredictably, and the prize depends on where it lands. It's all about luck and timing!",
   rules: [
  { id: 1, image: "https://lootrixtestgames.s3.ap-south-1.amazonaws.com/rules/1778758820038_win%20drop1.png", rule: "Win Drop is a one-time online casino game based on your bet amount and the number of balls. Each round has at least 10 balls. It costs the player bet x number of ball count." },
  { id: 2, image: "https://lootrixtestgames.s3.ap-south-1.amazonaws.com/rules/1778758820707_win%20drop2.png", rule: "Get a ball into a slot to earn the corresponding reward." },
  { id: 3, image: "https://lootrixtestgames.s3.ap-south-1.amazonaws.com/rules/1778758821993_win%20drop3.png", rule: "Adjust the prize’s risk level based on preferences. It affects both the main board and the roulette rewards." },
 { id: 4, image: "https://lootrixtestgames.s3.ap-south-1.amazonaws.com/rules/1778758822662_win%20drop4.png", rule: "Adjust the threshold at the start, then tap PLACE BET to drop balls. Each time a ball passes through it changes color and increases rewards to x2, x4 or x6." },
 { id: 5, image: "https://lootrixtestgames.s3.ap-south-1.amazonaws.com/rules/1778758823988_win%20drop5.png", rule: "The ball can also have a multiplying effect on the roulette wheel through the Multiplier Threshold." },
],
    popular: 1,
  },
};

export default function GamesDetails() {
  const { gamename } = useParams();
  const navigate = useNavigate();

  const [videoLoading, setVideoLoading] = useState(true);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [showGamePopup, setShowGamePopup] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Get game data directly from static map — no API
  const gameData = STATIC_GAMES[gamename?.toLowerCase()] || null;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector(".gemHEader");
      if (!nav) return;
      if (window.scrollY > 50) {
        nav.classList.add("scrolled");
      } else {
        nav.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [gamename]);

  useEffect(() => {
    setVideoLoading(true);
  }, [gamename]);

  useEffect(() => {
    return () => {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      const myObj = event.data;
      if (typeof myObj === 'string') {
        if (myObj.includes("CloseWindow")) {
          exitFullScreen();
        }
        if (myObj.includes("FullScreen")) {
          if (isFullScreen) exitFullScreen();
          setIsFullScreen(!isFullScreen);
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [isFullScreen]);

  const handlePlayNow = () => {
    setShowGamePopup(true);
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.background = "black";
    document.body.style.overflow = "hidden";
    window.lenis?.stop();
    document.querySelector(".gameVideo")?.pause();
  };

  // const [showMobileGame, setShowMobileGame] = useState(false);
const handlePlayMobile = () => {
  window.open(`https://gx.iqplay.live/${gameData.gamename}`, "_blank", "noopener,noreferrer");
};
  const closePopup = () => {
    setShowExitConfirm(true);
  };

  const confirmExit = () => {
    setShowExitConfirm(false);
    setShowGamePopup(false);
    document.documentElement.style.overflow = "auto";
    document.documentElement.style.background = "";
    document.body.style.overflow = "auto";
    window.lenis?.start();
    document.querySelector(".gameVideo")?.play();
  };

  const cancelExit = () => {
    setShowExitConfirm(false);
  };
  

  function exitFullScreen() {
    setShowGamePopup(false);
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    document.documentElement.style.background = "";
    document.querySelector('.gameVideo')?.play();
    if (document.fullscreenElement || document.webkitFullscreenElement ||
      document.mozFullScreenElement || document.msFullscreenElement) {
      (document.exitFullscreen || document.mozCancelFullScreen ||
        document.webkitExitFullscreen || document.msExitFullscreen)?.call(document);
    }
  }

  const handleBackClick = () => {
    const returnToSection = sessionStorage.getItem('returnToSection');
    navigate('/');
    setTimeout(() => {
      if (returnToSection === 'games') {
        document.getElementById('games')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      sessionStorage.removeItem('returnToSection');
    }, 100);
  };

  if (!gameData) {
    return <div style={{ padding: '50px', textAlign: 'center' }}></div>;
  }

  return (
    <div style={{ marginTop: "-12px" }} id="top">
    <Helmet>
        <title>{gameData.metaTitle}</title>
        <meta name="description" content={gameData.metaDescription} />
      </Helmet>
      <div className="float-text show-on-scroll">
        <span>
          <a onClick={scrollToTop} style={{ cursor: 'pointer' }}>Scroll to top</a>
        </span>
      </div>
      <div className="scrollbar-v show-on-scroll" onClick={scrollToTop} style={{ cursor: 'pointer' }}></div>

      <div className="gemHEader">
        <header className="header">
          <div className="container cusHeadCont">
            <div className="row cusHead_game">
              <div className="col-md-6 cusHeadBg_games">
                <div className="de-flex sm-pt10">
                  <div className="de-flex-col">
                    <div className="de-flex-col logohead">
                      <div className="backBTNmain">
                        <button className="SPA_button backContBTn" onClick={handleBackClick}>
                          <div className="button-content">
                            <div className="icon-wrapperback">
                              <img src={contArrow} alt="" className="whitE" />
                            </div>
                          </div>
                          <div className="hover-content">
                            <div className="icon-wrapperback">
                              <img src={contArrowblack} alt="" className="bacK" />
                            </div>
                          </div>
                        </button>
                        <div className="Gametitlename">{gameData.titlename}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>

      <div className="no-bottom no-top" id="content">
        <div id="top" />
        <div className="no-bottom">
          <div className="container">
            <div className="row">
              <div className="AB_right_section videoSECTION">
                <div className="Video_card">
                  <div className="maskdiv">
                    {videoLoading && (
                      <div className="videoLoader">
                        <div className="spinner"></div>
                      </div>
                    )}
                    <video
                      key={gameData.gamename}
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="metadata"
                      poster={gameData.poster_image}
                      className="gameVideo"
                      onCanPlayThrough={() => setVideoLoading(false)}
                    >
                      <source src={gameData.banner_video} type="video/mp4" />
                    </video>
                    <div className="Maskbackground" />
                  </div>

                  <div className="textPlayMain">
                    <div className="videOtext">{gameData.gameinfo}</div>
                    <button className="SPA_button ContBTn desktop" onClick={handlePlayNow} >
                      <div className="button-content">
                        <div className="icon-wrapper">
                          <img src={playbtn} alt="play" className="contArrow" />
                        </div>
                        <span>Play Now</span>
                      </div>
                      <div className="hover-content">
                        <div className="icon-wrapper">
                          <img src={PlaybuttonHover} alt="play" className="contArrow" />
                        </div>
                        <span>Play Now</span>
                      </div>
                    </button>
                       <button className="SPA_button ContBTn mobile" onClick={handlePlayMobile} >
                      <div className="button-content">
                        <div className="icon-wrapper">
                          <img src={playbtn} alt="play" className="contArrow" />
                        </div>
                        <span>Play Now</span>
                      </div>
                      <div className="hover-content">
                        <div className="icon-wrapper">
                          <img src={PlaybuttonHover} alt="play" className="contArrow" />
                        </div>
                        <span>Play Now</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <Rules rules={gameData.rules || []} />
          </div>
          <div className="soft-divider"></div>
        </div>

        <section className="jarallax pb20 padding0">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <Popular games={[]} categories={[]} />
              </div>
            </div>
          </div>
        </section>

        <footer className="gamefot">
          <div className="subfooter">
            <img className="logo-main" src={logo} alt="" />
          </div>
          <div className="subfooter">
            <hr className="footerhr" />
          </div>
          <div className="subfooter">
            ©{new Date().getFullYear()} <span className="Lootrix">iqplay.</span>All Rights Reserved
          </div>
        </footer>
      </div>


{/* {showMobileGame && (
  <iframe
    key={gamename}
    src="https://gx.iqplay.live/"
    title="Game Frame"
    className="mobileGameFrame"
    allow="clipboard-write; clipboard-read; screen-wake-lock; fullscreen; autoplay; accelerometer; gyroscope; xr-spatial-tracking"
  />
)} */}


      {showGamePopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 9999,
            display: "flex",
          }}
          data-lenis-prevent
        >
          <div className="ScreenParent">
            <Screen gamename={gameData.gamename} onClose={closePopup} />
          </div>

          {showExitConfirm && (
            <div className="EXITPOP_position">
              <div className="EXITPOP_main">
                <div className="overpadding">
                  <h3 className="EXIT_TITLE">Exit Game</h3>
                  <h3 className="EXIT_heading">Are you sure you want to exit the game?</h3>
                  <div className="EXITPOP_mainCHILD">
                    <button onClick={cancelExit} className="popNo">Cancel</button>
                    <button onClick={confirmExit} className="popYES">Yes, Exit</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}